module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/sell-property.8fe7d1541ac3f75896e83cb1ce6e4eeb.jpg";